import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";
import { authLogin } from "../../apis/auth/authLogin";
import * as EncryptedKey from "../../constants/encryptedRootReducerKeys";

const initialState = {
    loading: false,
    data: null,
    error: null
}

 const authLoginSlice = createSlice({
    name: 'authLogin',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(REHYDRATE, (state, action) => {
            const persistedAuthLoginState =
                action?.payload?.[EncryptedKey.authLogin] ??
                action?.payload?.authLogin;

            if (!persistedAuthLoginState) {
                return state;
            }

            return {
                ...state,
                ...persistedAuthLoginState,
                loading: false,
                error: null
            }
        })

        builder.addCase(authLogin.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(authLogin.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(authLogin.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default authLoginSlice.reducer
